import { render, staticRenderFns } from "./SurveyUploader.vue?vue&type=template&id=567729f6"
import script from "./SurveyUploader.vue?vue&type=script&lang=js"
export * from "./SurveyUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports